var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 960",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 960) scale(1 -1)",
    d: "M558 198L380 198Q354 198 336 216Q318 234 318 260Q318 286 336 304Q354 322 380 322L558 322Q558 322 558 322Q558 322 558 322L558 418Q558 418 558 418Q558 418 558 418L420 418Q394 418 376 436Q358 454 358 480Q358 506 376 524Q394 542 420 542L558 542Q558 542 558 542Q558 542 558 542L558 638Q558 638 558 638Q558 638 558 638L380 638Q354 638 336 656Q318 674 318 700Q318 726 336 744Q354 762 380 762L558 762Q610 762 646 726Q682 690 682 638L682 564Q682 530 659.5 506Q637 482 604 480Q637 478 659.5 454Q682 430 682 396L682 322Q682 270 646 234Q610 198 558 198Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer3);
export default __webpack_public_path__ + "static/media/timer_3.b2a6a60fcf85b3069b0a83477e66260f.svg";
export { ForwardRef as ReactComponent };